export const CategoriesIcon = () => {
  return (
    <svg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.91667 2.375H2.375V7.91667H7.91667V2.375Z' stroke='#1F1F23' stroke-width='1.63447' stroke-linecap='round' stroke-linejoin='round' />
      <path d='M16.6257 2.375H11.084V7.91667H16.6257V2.375Z' stroke='#1F1F23' stroke-width='1.63447' stroke-linecap='round' stroke-linejoin='round' />
      <path
        d='M16.6257 11.083H11.084V16.6247H16.6257V11.083Z'
        stroke='#1F1F23'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M7.91667 11.083H2.375V16.6247H7.91667V11.083Z'
        stroke='#1F1F23'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
